/* Herbaris 2026 homepage: dots under the Judge.me reviews carousel.
   The widget only offers arrows. Its cards are rendered client-side, and its
   own state (window.jdgmCarouselMode[blockId].index) plus
   jdgmCarouselUtils.showCard() are what the arrows use, so the dots drive the
   same state. They follow the autoplay through the "active" class the widget
   toggles on each card. If any of that is missing, nothing changes and the
   arrows stay. */
(() => {
  const CAROUSEL = '[id$="__177452887854a0afdc"] .jdgm-testimonials-carousel';

  function build(carousel) {
    const id = carousel.dataset.jdgmBlockId;
    const mode = window.jdgmCarouselMode && window.jdgmCarouselMode[id];
    const utils = window.jdgmCarouselUtils;
    const container = carousel.querySelector('.jdgm-testimonials-container');
    const row = carousel.querySelector('.jdgm-arrows--bottom');
    const cards = carousel.querySelectorAll('.jdgm-testimonial');
    if (!id || !mode || !utils || !container || !row || cards.length < 2) return false;

    const nav = document.createElement('div');
    nav.className = 'hb-review-dots';
    const dots = Array.from(cards, (card, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'hb-review-dots__dot';
      dot.setAttribute('aria-label', `Recenzia ${i + 1} din ${cards.length}`);
      dot.addEventListener('click', () => {
        mode.index = i;
        utils.showCard(carousel, mode);
      });
      nav.append(dot);
      return dot;
    });

    const sync = () => {
      const current = Array.from(container.querySelectorAll('.jdgm-testimonial')).findIndex((card) =>
        card.classList.contains('active')
      );
      dots.forEach((dot, i) => dot.setAttribute('aria-current', i === current ? 'true' : 'false'));
    };

    new MutationObserver(sync).observe(container, { subtree: true, attributes: true, attributeFilter: ['class'] });
    row.append(nav);
    row.classList.add('hb-has-dots');
    sync();
    return true;
  }

  // The widget loads its script and reviews after the page, so wait for the
  // cards; give up quietly after 30 s.
  let tries = 0;
  const timer = setInterval(() => {
    const carousel = document.querySelector(CAROUSEL);
    if ((carousel && build(carousel)) || ++tries > 60) clearInterval(timer);
  }, 500);
})();
